import type {
  GovernanceDocumentType,
  DocumentLifecycleStatus,
} from "../../../api/frameworksApi";

/* ── Constants ── */
export const DOCUMENT_TYPES: { value: GovernanceDocumentType; label: string }[] =
  [
    { value: "POLICY", label: "Policy" },
    { value: "STANDARD", label: "Standard" },
    { value: "GUIDELINE", label: "Guideline" },
    { value: "PROCEDURE", label: "Procedure" },
  ];

export const DOC_TYPE_COLORS: Record<string, string> = {
  POLICY:
    "bg-blue-50 dark:bg-blue-500/10 text-blue-700 dark:text-blue-300 ring-1 ring-blue-200/60 dark:ring-blue-500/20",
  STANDARD:
    "bg-teal-50 dark:bg-teal-500/10 text-teal-700 dark:text-teal-300 ring-1 ring-teal-200/60 dark:ring-teal-500/20",
  GUIDELINE:
    "bg-orange-50 dark:bg-orange-500/10 text-orange-700 dark:text-orange-300 ring-1 ring-orange-200/60 dark:ring-orange-500/20",
  PROCEDURE:
    "bg-fuchsia-50 dark:bg-fuchsia-500/10 text-fuchsia-700 dark:text-fuchsia-300 ring-1 ring-fuchsia-200/60 dark:ring-fuchsia-500/20",
};

export const LIFECYCLE_STATUSES: {
  value: DocumentLifecycleStatus;
  label: string;
}[] = [
  { value: "DRAFT", label: "Draft" },
  { value: "IN_REVIEW", label: "In Review" },
  { value: "APPROVED", label: "Approved" },
  { value: "PUBLISHED", label: "Published" },
  { value: "RETIRED", label: "Withdrawn" },
];

export const TITLE_MAX_LENGTH = 150;
export const EVIDENCE_TITLE_MAX = 100;
export const DAYS_MAX = 366;
// Max upload size (25 MB) — keep in sync with the "max 25 MB" hint text.
export const MAX_FILE_BYTES = 25 * 1024 * 1024;

/* ── Document-type badge colours ── */
export const docTypeBadgeStyles: Record<string, string> = {
  POLICY:
    "bg-blue-50 text-blue-700 ring-1 ring-blue-200 dark:bg-blue-500/20 dark:text-blue-300 dark:ring-1 dark:ring-blue-500/30",
  STANDARD:
    "bg-slate-100 text-slate-700 ring-1 ring-slate-300 dark:bg-slate-500/20 dark:text-slate-300 dark:ring-1 dark:ring-slate-500/30",
  GUIDELINE:
    "bg-teal-50 text-teal-700 ring-1 ring-teal-200 dark:bg-teal-500/20 dark:text-teal-300 dark:ring-1 dark:ring-teal-500/30",
  PROCEDURE:
    "bg-amber-50 text-amber-700 ring-1 ring-amber-200 dark:bg-amber-500/20 dark:text-amber-300 dark:ring-1 dark:ring-amber-500/30",
};

export const defaultDocTypeBadge =
  "bg-slate-100 text-slate-600 ring-1 ring-slate-200 dark:bg-slate-500/20 dark:text-slate-300 dark:ring-1 dark:ring-slate-500/30";
